module.exports = __webpack_public_path__ + "static/media/payment.56439fda.svg";